import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight, Save } from 'lucide-react';
import { useCreateBranch } from '../hooks/useBranches';

export function CreateBranchPage() {
  const navigate = useNavigate();
  const createMutation = useCreateBranch();
  const [formData, setFormData] = useState({ name: '', code: '', city: '', phone: '', address: '' });
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    
    try {
      // إرسال البيانات الحقيقية للباك إند
      await createMutation.mutateAsync({
        name: formData.name,
        code: formData.code || 'BR-' + Math.floor(Math.random() * 100),
        isActive: true
      } as any);
      
      // العودة لصفحة الفروع بعد نجاح الحفظ
      navigate('/branches');
    } catch (err: any) {
      console.error(err);
      setError('حدث خطأ أثناء حفظ الفرع، يرجى المحاولة مرة أخرى.');
    }
  };

  return (
    <div className="space-y-6" dir="rtl">
      <div className="flex items-center gap-3">
        <button onClick={() => navigate('/branches')} className="p-2 hover:bg-gray-100 rounded-lg">
          <ArrowRight size={20} />
        </button>
        <h1 className="text-2xl font-bold text-gray-900">إضافة فرع جديد</h1>
      </div>

      {error && (
        <div className="p-4 text-sm text-red-700 bg-red-50 rounded-lg border border-red-200">
          {error}
        </div>
      )}

      <form onSubmit={handleSubmit} className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
        <div className="p-6 space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">اسم الفرع *</label>
              <input 
                type="text" 
                required 
                className="w-full px-3 py-2.5 bg-gray-50 border border-gray-300 rounded-lg focus:bg-white outline-none" 
                value={formData.name} 
                onChange={e => setFormData({...formData, name: e.target.value})} 
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">كود الفرع (مثال: CAI-01) *</label>
              <input 
                type="text" 
                required
                className="w-full px-3 py-2.5 bg-gray-50 border border-gray-300 rounded-lg focus:bg-white outline-none" 
                value={formData.code} 
                onChange={e => setFormData({...formData, code: e.target.value})} 
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">المدينة / المحافظة</label>
              <input 
                type="text" 
                className="w-full px-3 py-2.5 bg-gray-50 border border-gray-300 rounded-lg focus:bg-white outline-none" 
                value={formData.city} 
                onChange={e => setFormData({...formData, city: e.target.value})} 
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">رقم هاتف الفرع</label>
              <input 
                type="tel" 
                className="w-full px-3 py-2.5 bg-gray-50 border border-gray-300 rounded-lg focus:bg-white outline-none" 
                value={formData.phone} 
                onChange={e => setFormData({...formData, phone: e.target.value})} 
              />
            </div>
            <div className="md:col-span-2">
              <label className="block text-sm font-medium text-gray-700 mb-2">العنوان الجغرافي للفرع</label>
              <input 
                type="text" 
                className="w-full px-3 py-2.5 bg-gray-50 border border-gray-300 rounded-lg focus:bg-white outline-none" 
                value={formData.address} 
                onChange={e => setFormData({...formData, address: e.target.value})} 
              />
            </div>
          </div>
        </div>
        <div className="px-6 py-4 bg-gray-50 border-t border-gray-200 flex justify-end gap-3">
          <button 
            type="button" 
            onClick={() => navigate('/branches')} 
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50"
          >
            إلغاء
          </button>
          <button 
            type="submit" 
            disabled={createMutation.isPending}
            className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-white bg-orange-600 rounded-lg hover:bg-orange-700 disabled:bg-gray-400 transition-colors"
          >
            <Save size={16} /> 
            {createMutation.isPending ? 'جاري الحفظ...' : 'حفظ الفرع'}
          </button>
        </div>
      </form>
    </div>
  );
}
